import React, { useEffect } from "react";
import { ConfigProvider } from "antd";
import { getThemeConfig } from "styles/themes/config";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ru_RU from "antd/lib/locale/ru_RU";
import { observer } from "mobx-react";
import { useStores } from "stores";
import { requestWithNotify } from "utils";
import { useNotificationContext } from "providers";

export const WebSettingsProvider: React.FC<{ children: React.ReactNode }> = observer(({ children }) => {
  const { webSettings } = useStores();
  const { openNotification } = useNotificationContext();

  useEffect(() => {
    requestWithNotify({
      fetchFn: webSettings.fetch,
      openNotification: openNotification,
      showErrorNotification: false,
    });
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        {!webSettings.favicon.statuses.fetchError ? (
          webSettings.favicon.data ? (
            <link rel="shortcut icon" href={webSettings.favicon.data?.url} />
          ) : null
        ) : (
          <link rel="shortcut icon" href="favicon.svg" />
        )}
        <title>{webSettings.settings.data.title}</title>
      </Helmet>

      <ConfigProvider theme={getThemeConfig(webSettings.settings.data.theme)} locale={ru_RU}>
        {children}
      </ConfigProvider>
    </HelmetProvider>
  );
});
